import type { History } from 'history';
import type { OpenInDestination } from '../types';
import { assertExhaustive, navigateToReportLab, navigateToStudioView, type StudioTemplateState } from 'venn-utils';

export const getDestinationFriendlyName = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'Studio';
    case 'report_lab':
      return 'Report Lab';
    default:
      throw assertExhaustive(destination);
  }
};

export const getDestinationShortName = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'Studio';
    case 'report_lab':
      return 'Report';
    default:
      throw assertExhaustive(destination);
  }
};

export const getTemplateType = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'TEARSHEET_TEMPLATE';
    case 'report_lab':
      return 'REPORT_TEMPLATE';
    default:
      throw assertExhaustive(destination);
  }
};

export const navigateToDestination = (destination: OpenInDestination, history: History, state: StudioTemplateState) => {
  switch (destination) {
    case 'studio':
      return navigateToStudioView(history, state);
    case 'report_lab':
      return navigateToReportLab(history, state);
    default:
      throw assertExhaustive(destination);
  }
};
